/**
 * Certificate action types for generate/recreate operations
 */
export enum CertificateAction {
    /** Generate a new certificate */
    GENERATE = 'generate',
    /** Recreate an existing certificate */
    RECREATE = 'recreate'
}

export type CertificateActionType = CertificateAction.GENERATE | CertificateAction.RECREATE;
